/**
 * @generated SignedSource<<1556fa64afd963885ab80d0d98618333>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useBudgetEditor_BudgetQuery$variables = {
  id: string;
};
export type useBudgetEditor_BudgetQuery$data = {
  readonly budget: {
    readonly entries: ReadonlyArray<{
      readonly amountCents: number;
      readonly period: string;
      readonly rowKey: string;
    }>;
    readonly id: string;
    readonly name: string;
    readonly year: number;
  } | null | undefined;
};
export type useBudgetEditor_BudgetQuery = {
  response: useBudgetEditor_BudgetQuery$data;
  variables: useBudgetEditor_BudgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowKey",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBudgetEditor_BudgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Budget",
        "kind": "LinkedField",
        "name": "budget",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BudgetEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBudgetEditor_BudgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Budget",
        "kind": "LinkedField",
        "name": "budget",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BudgetEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4e612684df60150ccef5f45568980ec",
    "id": null,
    "metadata": {},
    "name": "useBudgetEditor_BudgetQuery",
    "operationKind": "query",
    "text": "query useBudgetEditor_BudgetQuery(\n  $id: ID!\n) {\n  budget(id: $id) {\n    id\n    name\n    year\n    entries {\n      rowKey\n      period\n      amountCents\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "170028f05762ac1e235ece24a50d6dd0";

export default node;
